import React, { useState, useEffect } from 'react';
import { db } from '../../firebase/config';
import { getDocs, collection } from 'firebase/firestore';
import './LocationFetcher.scoped.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLocationDot } from '@fortawesome/free-solid-svg-icons';

const LocationFetcher = ({ children }) => {
    const [locations, setLocations] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
            const querySnapshot = await getDocs(collection(db, 'venues'));
            const locationsData = [];
            
            querySnapshot.forEach((doc) => {
                const data = doc.data();

                // Check if data has a 'location' property and it contains both 'latitude' and 'longitude'
                if (data.location && typeof data.location.latitude === 'number' && typeof data.location.longitude === 'number') {
                    const { latitude, longitude } = data.location;
                    locationsData.push({ ...data, latitude, longitude });
                } else {
                    console.warn(`Skipped document ${doc.id} as it does not have valid location data.`, data);
                }
            });

            setLocations(locationsData);
        };

        fetchData();
    }, []);

    if (locations.length === 0) {
        return (
            <div className='loading-state'>
                <div className="marker-loading"><FontAwesomeIcon icon={faLocationDot} size="3x" /></div>
                <p className='text-loading'>Huddling up the NFL Bars... Ready to kick off in just a moment!</p>
            </div>
            
        );
    }

    return React.cloneElement(children, { locations });
};

export default LocationFetcher;